import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./lib/auth.js";
import { useProfile } from "./lib/queries.js";
import { FullPageSpinner } from "./components/ui.js";
import Login from "./routes/Login.js";
import Onboarding from "./routes/Onboarding.js";
import Preferences from "./routes/Preferences.js";
import Dashboard from "./routes/Dashboard.js";
import DigestDetail from "./routes/DigestDetail.js";
import Settings from "./routes/Settings.js";

/**
 * Faz 2 yönlendirme (CLAUDE.md §7.2).
 *  • /login — oturum yoksa
 *  • /onboarding — oturum var ama profil tamamlanmamış (company boş)
 *  • / , /preferences — tam yetkili alan
 */
export default function App() {
  const { loading, session } = useAuth();
  if (loading) return <FullPageSpinner label="Z-Suite yükleniyor…" />;

  return (
    <Routes>
      <Route
        path="/login"
        element={session ? <Navigate to="/" replace /> : <Login />}
      />
      <Route
        path="/onboarding"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireAuth>
            <RequireOnboarding>
              <Dashboard />
            </RequireOnboarding>
          </RequireAuth>
        }
      />
      <Route
        path="/preferences"
        element={
          <RequireAuth>
            <RequireOnboarding>
              <Preferences />
            </RequireOnboarding>
          </RequireAuth>
        }
      />
      <Route
        path="/digest/:date"
        element={
          <RequireAuth>
            <RequireOnboarding>
              <DigestDetail />
            </RequireOnboarding>
          </RequireAuth>
        }
      />
      <Route
        path="/settings"
        element={
          <RequireAuth>
            <RequireOnboarding>
              <Settings />
            </RequireOnboarding>
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session } = useAuth();
  const location = useLocation();
  if (!session) return <Navigate to="/login" replace state={{ from: location }} />;
  return <>{children}</>;
}

/** Profil tamamlanmamışsa (company boş) onboarding'e yönlendirir. */
function RequireOnboarding({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { data: profile, isLoading } = useProfile(user?.id);
  if (isLoading) return <FullPageSpinner />;
  if (!profile?.company) return <Navigate to="/onboarding" replace />;
  return <>{children}</>;
}
